<template>
  <el-select v-model="model" :multiple="multiple" :filterable="filterable" :placeholder="placeholder" :allow-create="allowCreate" @change="clearLinkedFields">
    <el-option v-for="item of i18nItems" :class="computeColorIconClassName(item.value)" :label="item.computedLabel" :value="item.value" :key="item.value" />
  </el-select>
</template>

<script>
import { Component } from 'vue-property-decorator';
import BaseFormComponent from './component';

@Component({
  props: {
    items: { type: Array, required: true },
    multiple: { type: Boolean, default: false },
    filterable: { type: Boolean, default: false },
    colorIcons: { type: Boolean, default: false },
    allowCreate: { type: Boolean, default: false },
    alphabeticalOrder: { type: Boolean, default: false }
  }
})
export default class BaseFormComponentSelect extends BaseFormComponent {
  get i18nItems() {
    const items = this.items.map((item) => ({ ...item, computedLabel: this.computeItemLabel(item) }));
    return this.alphabeticalOrder && items.sort(compareItemComputedLabelsAsc), items;
  }

  computeItemLabel({ i18nLabel, label }) {
    return (i18nLabel && this.$tf(i18nLabel)) ?? label;
  }

  computeColorIconClassName(value) {
    return {
      'color-icon': this.colorIcons,
      [`color-icon_${value}`]: this.colorIcons
    };
  }
}

function compareItemComputedLabelsAsc(itemA, itemB) {
  return itemA.computedLabel.localeCompare(itemB.computedLabel);
}
</script>

<style lang="stylus">
$dark_mark_color = #1f2125;

.color-icon {
  &::after {
    width: 1em;
    right: 20px;
    height: 100%;
    font-size: 12px;
    position: absolute;
    background: center / 1em 1em no-repeat;
  }

  &:not(.selected)::after {
    content: '';
  }

  &_beige::after {
    color: $dark_mark_color;
    background-image: linear-gradient(beige, beige);
  }

  &_black::after {
    background-image: linear-gradient(black, black);
  }

  &_blue::after {
    background-image: linear-gradient(blue, blue);
  }

  &_brown::after {
    background-image: linear-gradient(brown, brown);
  }

  &_cyan::after {
    color: $dark_mark_color;
    background-image: linear-gradient(cyan, cyan);
  }

  &_lightblue::after {
    background-image: linear-gradient(lightblue, lightblue);
  }

  &_gold::after {
    color: $dark_mark_color;
    background-image: linear-gradient(gold, gold);
  }

  &_green::after {
    background-image: linear-gradient(green, green);
  }

  &_grey::after {
    background-image: linear-gradient(grey, grey);
  }

  &_orange::after {
    background-image: linear-gradient(orange, orange);
  }

  &_pink::after {
    color: $dark_mark_color;
    background-image: linear-gradient(pink, pink);
  }

  &_purple::after {
    background-image: linear-gradient(purple, purple);
  }

  &_red::after {
    background-image: linear-gradient(red, red);
  }

  &_silver::after {
    color: $dark_mark_color;
    background-image: linear-gradient(silver, silver);
  }

  &_violet::after {
    background-image: linear-gradient(violet, violet);
  }

  &_white::after {
    color: $dark_mark_color;
    background-image: linear-gradient(white, white);
  }

  &_yellow::after {
    color: $dark_mark_color;
    background-image: linear-gradient(yellow, yellow);
  }
}
</style>
